import { useLocation, useNavigate, useParams } from "react-router";
import Container from "../components/common/Container";
import styled from "styled-components";
import { Tabs } from "@mantine/core";
import EmployeeDetailTable from "../components/EmployeeDetail/Table";
import PageHeader from "../components/common/PageHeader";
import { useEffect, useRef, useState } from "react";
import { getEmployeeById } from "../api/employeeApi";
import EmployeeDetailForm from "../components/EmployeeDetail/EmployeeDetail";
import SaveIcon from "../components/common/Icons/SaveIcon";
import { useForm } from "@mantine/form";
import {
  combineValidators,
  validateMaxLength,
  validateMinLength,
  validateNoSpaces,
  validatePhoneNumberIsNumeric,
  validatePhoneNumberStartsWithZero,
  validateRequired,
} from "../utils/validations";
import EmployeeShiftDetails from "../components/EmployeeDetail/EmployeeShiftDetails";
import {
  createWorkPermit,
  getWorkPermitsForEmployee,
} from "../api/workPermitApi";
import WorkPermitsTable from "../components/EmployeeDetail/WorkPermitsTable";
import DocumentUpload from "../components/common/Inputs/DocumentUpload";
import DocumentsTable from "../components/EmployeeDetail/DocumentsTable";
import { useAuth } from "../context/AuthContext";

export type Employee = {
  _id: string;
  name: string;
  phone: string;
  companyId: string;
  isDeleted: boolean;
  department: string;
  position: string;
  shifts: any;
  workPermits: any;
  documents: any;
};

const EmployeeDetail = () => {
  const { id } = useParams();
  const { company } = useAuth();

  const location = useLocation();

  const [activeTab, setActiveTab] = useState<any>(
    location.state?.tab || "entry-exit"
  );
  const [employee, setEmployee] = useState<Employee>();

  const getEmployeeDetails = async () => {
    try {
      const data: any = await getEmployeeById(`${id}`);
      setEmployee(data?.data?.response);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getEmployeeDetails();
  }, []);

  const buttonRef = useRef<any>();
  const handleClick = () => {
    buttonRef.current.click();
  };

  const form = useForm({
    initialValues: {
      name: "",
      phone: "",
      department: "",
      isActive: "true",
      position: "",
    },
    validate: {
      name: validateRequired,
      phone: combineValidators(
        validateRequired,
        validatePhoneNumberStartsWithZero,
        validatePhoneNumberIsNumeric,
        validateNoSpaces,
        validateMinLength(11),
        validateMaxLength(11)
      ),
      department: validateRequired,
      isActive: validateRequired,
      position: validateRequired,
    },
  });

  return (
    <Container>
      <PageHeader
        pageTitle={"Çalışan Detayları"}
        isButtoned={activeTab === "detail" ? true : false}
        buttonText="Güncelle"
        buttonOnClick={handleClick}
        buttonIcon={<SaveIcon size={24} />}
        isButtonDisabled={!form.isDirty()}
      />

      {false ? (
        <div>Loading</div>
      ) : (
        <>
          <Tabs value={activeTab} onChange={setActiveTab} keepMounted={true}>
            <StyledTabsList mb={20}>
              {/* <StyledTabsTab value="detail">Personel Bilgileri</StyledTabsTab> */}
              <StyledTabsTab value="entry-exit">
                Giriş/Çıkış Detayları
              </StyledTabsTab>
              <StyledTabsTab value="work-permits">İzinler</StyledTabsTab>
              {company?.modules?.isDocumentUploadAvailable && (
                <StyledTabsTab value="documents">Özlük Belgeleri</StyledTabsTab>
              )}

              <StyledTabsTab value="shift-detail">
                Çalışma Düzeni
              </StyledTabsTab>
            </StyledTabsList>
            {/* <Tabs.Panel value="detail">
              <EmployeeDetailForm
                employee={employee}
                buttonRef={buttonRef}
                form={form}
              />
            </Tabs.Panel> */}
            <Tabs.Panel value="entry-exit">
              <EmployeeDetailTable />
            </Tabs.Panel>
            <Tabs.Panel value="work-permits">
              <WorkPermitsTable />
            </Tabs.Panel>
            {company?.modules?.isDocumentUploadAvailable && (
              <Tabs.Panel value="documents">
                <DocumentsTable
                  reFetchData={getEmployeeDetails}
                  documents={employee?.documents}
                />
              </Tabs.Panel>
            )}
            <Tabs.Panel value="shift-detail">
              {/* Atama/kaldırma ve haftalık program bileşenin kendi içinde;
                  veriyi de kendisi çekiyor (plan 2.24). */}
              <EmployeeShiftDetails employeeId={id!} />
            </Tabs.Panel>
          </Tabs>
        </>
      )}
    </Container>
  );
};

export default EmployeeDetail;

/*
 * Sekme şeridi dar ekranda 132px taşıyordu (`w="max-content"` + sarma yok).
 * Sarmak yerine KAYDIRMA: sarılmış sekme şeridi bozuk görünür, kaydırma
 * mobilde beklenen davranış. Kaydırma çubuğu gizli, dokunmatikte gerekmiyor.
 */
const StyledTabsList = styled(Tabs.List)`
  width: max-content;
  max-width: 100%;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const StyledTabsTab = styled(Tabs.Tab)`
  color: #9ca3af;
  &[aria-selected="true"] {
    color: #5c26ff;
    border-color: #5c26ff;
    border-bottom-width: 3px;
  }
`;
